import { render, staticRenderFns } from "./DescargarCatalogo.vue?vue&type=template&id=306362f7&scoped=true"
import script from "./DescargarCatalogo.vue?vue&type=script&lang=js"
export * from "./DescargarCatalogo.vue?vue&type=script&lang=js"
import style0 from "./DescargarCatalogo.vue?vue&type=style&index=0&id=306362f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306362f7",
  null
  
)

export default component.exports